export default "__VITE_ASSET__DphbwWnN__"